import {
  Icons,
  HexIcon,
  Placeholder as StatusMessage,
} from '@cast/design-system';

import { useThemeColor } from 'hooks/theme';

type Props = {
  total?: number;
};

export const ChecksPassed = ({ total }: Props) => {
  const color = useThemeColor('green.500');
  if (!total) {
    return null;
  }

  return (
    <StatusMessage
      sx={{ pt: 32 }}
      icon={
        <HexIcon
          variant="success"
          icon={<Icons.ShieldCheck weight="fill" color={color} />}
          size={64}
        />
      }
      title={`${total} checks passed`}
      body="Your cluster doesn’t have any failed checks"
      testId="compliance-checks-passed"
    />
  );
};
